import { useState } from "react";
import ModelPage from "../../ModelPage";
import Filter from "../../../../assets/img/skimatic-filter.png";
import Holder from "../../../../assets/img/drink-holder.png";
import QrCode from "../../../../assets/img/qr__deluxe-off-grid.png";

const galleryData = {
	details: {
		items: [
			{
				image: "images/Deluxe_WPC_Grey_OffGrid_r02.jpg",
				secondImage: "images/Deluxe_WPC_Brown_OffGrid_r02.jpg",
				title: "Deluxe Off-Grid Acrylic Hot Tub",
				subtitle: "PACKAGE",
				text: "The Deluxe Off Grid Package is the perfect union of modern convenience and an age-old ritual of relaxation.  With our UK-first acrylic liner, integrated external stove and warm thermowood exterior cladding, this package delivers a tub that’s built to last as long as the countryside it nestles into.",
			},
			{
				image: "images/Deluxe_Lady.jpeg",
				title: "I wish there were more companies like this one",
				subtitle: "TESTIMONIALS",
				text: "“The team at royal were genuinely friendly and so helpful in helping us choose the right tub for us. Quality people and product and a price that was just right. The tub has exceeded our expectations, following Kelly and Simons advice we decided to go for a wood fired with fibre glass insert with LED lighting and massage system.”",
			},
			{
				image: "images/Deluxe_Friends.jpeg",
				title: "Customer Reviews",
				subtitle: "TESTIMONIALS",
				text: "“We have been considering a hot tub purchase for some time and this was exactly what we were looking for. The tub is well made and very comfortable, looks stylish and is easy to heat up and use. Royal Tubs were very helpful and offered a great service at a genuinely great price.”",
			},
			{
				image: "images/Deluxe_Children.png",
				title: "It’s like having a holiday in our back garden",
				subtitle: "TESTIMONIALS",
				text: "“I was absolutely thrilled to receive this hot tub just in time for my sunshine birthday. The children love it and it brings a new dimension to self isolation. It was cost effective, delivered 2 days after purchase and the service was fantastic.”",
			},
			{
				image: "images/Deluxe_Review.jpg",
				title: "Truly immaculate service and really amazing hot tub",
				subtitle: "TESTIMONIALS",
				text: "“I have been so impressed from beginning to end and the quality of the tub is incredible. We are over the moon and Royal Tubs have held our hands through the whole things making sure we got a tub that worked perfectly in our space/ and for our needs etc .. I cannot recommend these guys enough”",
			},
			{
				image: "images/Deluxe_Review2.jpg",
				title: "Absolutely delighted with it!",
				subtitle: "TESTIMONIALS",
				text: "“We ordered one of the deluxe tubs with Air and Hydro jets and it haven’t been out of it since it arrived.  In current weather I light a fire late afternoon and by early evening it’s toasty warm and ready for the family.  I couldn’t recommend Royal Tubs more; great service, great product.  What more could we ask!”",
			}
		],
	},
};

const linerColor = [
	{
		id: 1,
		price: 0,
		label: "Charcoal",
		color: "#e8e4e4",
		image: "images/white.png",
		modelUID: "bcee344f594542e49d8bdf461b19c06a",
	},
	{
		id: 3,
		price: 0,
		label: "Teak",
		color: "#585454",
		image: "images/gray.png",
		modelUID: "ba1781f79ec3453683c7f2bb50cf1acf",
	},
];

const keyFeaturesData = {
    text: "<h2>Key Features</h2><p>Extra-durable wood-plastic composite cladding meets an interior shaped for comfort, creating a luxury centrepiece you’ll never want to leave.</p><p>The Premium package consists of 14 wood fired hot tub elements that will cover everything you need for a perfect hot tubbing needs:</p>",
    features: [
        {
            title: "Deluxe acrylic hot tub",
            value: "(£2999 value)",
        },
        {
            title: "External integrated heater",
            value: "(£525 value)",
        },
        {
            title: "Stainless steel chimney with a heat guard",
            value: "(£125 value)",
        },
        {
            title: "304 steel grade upgrade",
            value: "(£210 value)",
        },
        {
            title: "Wood-Plastic Composite exterior cladding",
            value: "(£525 value)",
        },
        {
            title: "Insulated lid",
            value: "(£425 value)",
        },
        {
            title: "Stainless steel straps",
            value: "(£125 value)",
        },
        {
            title: "1 x mini bar / drink holder",
            value: "(£55 value)",
        },
        {
            title: "High-flow drain tap",
            value: "(£70 value)",
        },
        {
            title: "Stirring paddle",
            value: "(£55 value)",
        },
        {
            title: "Wide bespoke steps",
            value: "(£210 value)",
        }
    ],
    details: {
        items: [
            {
                image: "images/chimney-heat-guard-2.png",
                title: "Chimney Heat Guard",
                subtitle: "FLUE & DRAIN",
                text: "Relax with complete peace of mind. Surrounding the flue, this cost-effective safety add-on prevents injury from accidental contact with the chimney.",
            },
            {
                image: "images/high-flow-drain-tap-deluxe.png",
                title: "High-Flow Drain Tap",
                subtitle: "FLUE & DRAIN",
                text: "Make maintenance easy – you’ll never have to get in a cold tub to drain down with a tapping outside. Also slashes the time to drain your tub, and allows connection to a draining hose (if you’d prefer to not flood the garden).",
            },
        ],
    },
};

const specs = {
	title: "Specifications",
	specs: [
		{
			title: "Capacity:",
			text: "Fits 6-8 adults",
		},
		{
			title: "Package weight:",
			text: "418,8 lbs (190 kg)",
		},
		{
			title: "Height:",
			text: "43 inches (1100 mm)",
		},
		{
			title: "External diameter:",
			text: "78,7 inches (2000 mm)",
		},
		{
			title: "Internal width:",
			text: "70,9 inches (1800 mm)",
		},
		{
			title: "Depth:",
			text: "33,5 inches (850 mm)",
		},
		{
			title: "Chimney height:",
			text: "106,3 x 114,2 inches (2,7 – 2,9 m) measured from the ground up",
		},
		{
			title: "Water volume:",
			text: "317 gallons (1200 l)",
		},
		{
			title: "Heating time:",
			text: "Summer ± 1.5 hrs, Winter ± 2.5 hrs",
		},
		{
			title: "Heater fuel:",
			text: "Softwood/Hardwood",
		},
		{
			title: "Main heater material:",
			text: "Stainless steel (304 grade)",
		},
	],
	details: {
		items: [
			{
				image: "images/chimney-heat-guard-2.png",
				title: "Chimney Heat Guard",
				subtitle: "FLUE & DRAIN",
				text: "Relax with complete peace of mind. Surrounding the flue, this cost-effective safety add-on prevents injury from accidental contact with the chimney.",
			},
			{
				image: "images/high-flow-drain-tap-deluxe.png",
				title: "High-Flow Drain Tap",
				subtitle: "FLUE & DRAIN",
				text: "Make maintenance easy – you’ll never have to get in a cold tub to drain down with a tapping outside. Also slashes the time to drain your tub, and allows connection to a draining hose (if you’d prefer to not flood the garden).",
			},
		],
	},
};

const headlineData = {
	title: "WPC Deluxe Off-Grid Acrylic Hot Tub Package",
	discount: 18,
};

const breadcrumbData = [
	{
		title: "Deluxe Hot Tub",
		active: true,
	},
	{
		title: "Packages",
		active: true,
	},
	{
		title: "Deluxe Premium",
		active: false,
	},
];

const buttonLink =
	"https://sketchfab.com/models/bcee344f594542e49d8bdf461b19c06a/embed-ar";

const customData = {
	Size: "Deluxe",
	Heater: "External Integrated",
	"Heater Upgrades": "304 Steel Grade, Glass Heater Door, Stainless steel chimney with a cap",
	Wood: "WPC",
	"Wood Treatment": "Treated",
	"Liner Type": "Pearl White Acrylic",
	Lid: "Insulated",
	"Flue / Drain Add-ons": "High-Flow Drain Tap, Chimney heat guard",
	"External Add-ons": "Mini Bar, Stirring Paddle, Wide Bespoke Steps, Stainless steel decorative straps",
};

const Package4 = ({ backToLabel }) => {
	const [color, setColor] = useState(0);
	const details = {
		base: {
			title: "Deluxe Off-Grid Acrylic Hot Tub",
			price: 4800,
			configuredOptionsTotal: 2050,
			SRP: 5800,
			oldPrice: 5800,
		},
		heater: [
			{
				title: "External integrated",
				price: 525,
			},
			{
				title: "Glass heater door upgrade",
				price: 65,
			},
			{
				title: "304-grade stainless steel upgrade",
				price: 265,
			},
		],
		InteriorAndExterior: [
			{
				title: `Wood-Plastic Composite cladding - ${linerColor[color].label}`,
				price: 525,
			},
			{
				title: "Wood treatment",
				price: 55,
			},
			{
				title: "Insulated lid",
				price: 0,
			},
			{
				title: "Stainless steel straps",
				price: 0,
			},
			{
				title: "1 x mini-bar/drink holder",
				price: 0,
			},
			{
				title: "High-flow drain tap",
				price: 0,
			},
			{
				title: "Stirring paddle",
				price: 0,
			},
			{
				title: "Wide bespoke steps",
				price: 0,
			},
			{
				title: "Pearl White liner",
				price: 0,
			},
		],
		accesories: [
			{
				id: 2,
				label: "Submersive Skimatic Filter",
				price: 210,
				name: "submersive-skimatic-filter",
				image: Filter,
			},
			{
				id: 3,
				label: "Mini Bar/Drink Holder",
				price: 55,
				name: "mini-bar",
				maxQuantity: 3,
				sideNotes:
					"Note: Deluxe premium package includes 1 Drink Holder. However, above you are able to add up to 3 more to meet your comfort wants and needs.",
				image: Holder,
			},
		],
	};

	return (
		<ModelPage
			wooId={3952}
			modelUID="bcee344f594542e49d8bdf461b19c06a"
			qrCode={QrCode}
			videoUrl="https://www.youtube.com/embed/qu8BQjF3E8g"
			backToLabel={backToLabel}
			headlineData={headlineData}
			breadcrumbData={breadcrumbData}
			specs={specs}
			details={details}
			galleryData={galleryData}
			keyFeaturesData={keyFeaturesData}
			color={color}
			linerColor={linerColor}
			setColor={setColor}
			buttonLink={buttonLink}
			customData={customData}
		/>
	);
};

export default Package4;
